import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-quote',
    styleUrl: 'sew-ws-quote.scss',
    shadow: true,
})
export class SewWsQuote {
    @Element() el: HTMLSewWsQuoteElement;
    @Prop({ reflect: true }) noGrid = false;
    @Prop({ reflect: true }) noMargin = false;

    render() {
        return (
            <Host class={{ 'has-picture': !!this.el.querySelector('sew-picture') }}>
                <div class="main-content-container">
                    <svg class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 171 145">
                        <path
                            d="m0 0h74.7265416v78.2539683c0 43.8835977-21.6997319 66.1322747-65.09919576 66.7460317h-9.62734584v-36.365079h10.0857909c7.3351206-.306879 12.7600536-2.761905 16.2747989-7.36508 3.5147453-4.6031743 5.272118-11.6613754 5.272118-21.1746029v-7.3650794h-31.6327078zm171 0v78.2539683c0 43.8835977-21.699732 66.1322747-65.099196 66.7460317h-9.6273456v-36.365079h10.0857906c7.335121-.306879 12.836461-2.761905 16.504022-7.36508 3.66756-4.6031743 5.50134-11.6613754 5.50134-21.1746029v-7.3650794h-32.0911526v-72.7301587z"
                            fill="currentColor"
                        />
                    </svg>
                    <slot></slot>
                </div>
            </Host>
        );
    }
}
